import { render, staticRenderFns } from "./ScheduleThanks.vue?vue&type=template&id=2c208c90&scoped=true&"
import script from "./ScheduleThanks.vue?vue&type=script&lang=ts&"
export * from "./ScheduleThanks.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c208c90",
  null
  
)

export default component.exports